import React from 'react';
import { useNavigate } from 'react-router-dom';

export function LoginRequiredModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  if (!isOpen) {
    return null;
  }

  // '확인' 버튼 클릭 핸들러
  const handleConfirm = () => {
    onClose();        // 팝업 닫기
    navigate('/login'); // ⭐️ /login 경로로 이동
  };

  // '취소' 버튼 클릭 핸들러
  const handleCancel = () => {
    onClose();        // 팝업 닫기
  };

  return (
    // ⭐️ 배경 (Backdrop)
    <div style={modalStyles.backdrop}>
      {/* ⭐️ 모달 내용 컨테이너 */}
      <div style={modalStyles.content}>
        
        {/* 메시지 */}
        <p style={modalStyles.message}>
          로그인이 필요합니다.
        </p>
          <p style={modalStyles.message2}>
          로그인 후 함께 해주세요😊
        </p>
        
        {/* 버튼 그룹 */}
        <div style={modalStyles.buttonGroup}>
          
          <button 
            onClick={handleCancel} 
            style={modalStyles.cancelButton}
          >
            취소
          </button>
          
          <button 
            onClick={handleConfirm} 
            style={modalStyles.confirmButton}
          >
            확인
          </button>
          
        </div>
      </div>
    </div>
  );
}

const modalStyles = {
    // 전체 화면 배경 (스크롤 방지 및 반투명 검은색)
    backdrop: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999, // 최상단에 표시
    },
    // 팝업 박스
    content: {
        backgroundColor: 'white',
        borderRadius: '10px',
        width: '85%',
        maxWidth: '350px',
        paddingTop: '25px',
        overflow: 'hidden',
        textAlign: 'center',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
    },
    message: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '20px',
        padding: '0 20px',
    },
        message2: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '40px',
        padding: '0 20px',
    },
    buttonGroup: {
        display: 'flex',
        borderTop: '1px solid #eee',
        width: '100%',
    },
    baseButton: {
        flex: 1,
        padding: '15px 10px',
        fontSize: '16px',
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
        backgroundColor: 'white',
        transition: 'background-color 0.1s',
    },
    cancelButton: {
        // 취소 (좌측, 흰색)
        flex: 1,
        padding: '15px 10px',
        fontSize: '16px',
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
        backgroundColor: 'white',
        transition: 'background-color 0.1s',
        color: '#888',
        borderRight: '1px solid #eee', // 버튼 사이 구분선
    },
    confirmButton: {
        // 확인 (우측, 빨간색)
        flex: 1,
        padding: '15px 10px',
        fontSize: '16px',
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
        backgroundColor: 'white',
        transition: 'background-color 0.1s',
        color: '#ff4d4f', // 빨간색
    },
};